export function converterColagemWord(html, texto = '') {
  if (!html || !/(?:mso-|class=["']?Mso|xmlns:w=|<o:p\b)/i.test(html)) return null;
  const body = new DOMParser().parseFromString(html, 'text/html').body;
  body.querySelectorAll('style, script, meta, xml').forEach((node) => node.remove());
  const paragraphs = Array.from(body.querySelectorAll('p, h1, h2, h3, li'));
  // O Word pode enviar um único parágrafo HTML para várias linhas do clipboard.
  // Nesse caso, manter o HTML criaria um único item enorme e grudaria os títulos.
  const lines = texto.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length > paragraphs.length && paragraphs.length) {
    const escaped = document.createElement('div');
    return lines.map((line) => {
      escaped.textContent = line;
      return `<p>${escaped.innerHTML}</p>`;
    }).join('');
  }
  let result = '';
  let list = '';
  paragraphs.forEach((paragraph) => {
    const copy = paragraph.cloneNode(true);
    // Um <li> do Word pode conter a lista inteira dos seus filhos.
    // Cada filho será tratado separadamente, sem repetir o texto no pai.
    copy.querySelectorAll('ol, ul').forEach((node) => node.remove());
    copy.querySelectorAll('[style*="mso-list"]').forEach((node) => {
      if (/mso-list\s*:\s*ignore/i.test(node.getAttribute('style') || '')) node.remove();
    });
    copy.querySelectorAll('*').forEach((node) => {
      const style = node.getAttribute('style') || '';
      const bold = /font-weight\s*:\s*(bold|[7-9]00)/i.test(style);
      const italic = /font-style\s*:\s*italic/i.test(style);
      const tag = node.tagName.toLowerCase();
      if (tag === 'br') return;
      const safe = ['b', 'strong', 'i', 'em', 'u', 'a'].includes(tag);
      const replacement = document.createElement(bold || tag === 'b' ? 'strong' : italic || tag === 'i' ? 'em' : safe ? tag : 'span');
      if (tag === 'a' && /^(https?:|mailto:)/i.test(node.getAttribute('href') || '')) {
        replacement.setAttribute('href', node.getAttribute('href'));
      }
      while (node.firstChild) replacement.appendChild(node.firstChild);
      node.replaceWith(replacement);
    });
    if (!copy.textContent.trim()) return;
    const isList = paragraph.tagName === 'LI' || /mso-list\s*:/i.test(paragraph.getAttribute('style') || '');
    const marker = paragraph.querySelector('[style*="mso-list"]')?.textContent?.trim() || '';
    const type = isList ? (/^[•·-]/.test(marker) || paragraph.parentElement?.tagName === 'UL' ? 'ul' : 'ol') : '';
    const level = (paragraph.getAttribute('style') || '').match(/mso-list:[^;]*level(\d+)/i);
    let nesting = 0;
    for (let node = paragraph.parentElement; node; node = node.parentElement) {
      if (node.tagName === 'OL' || node.tagName === 'UL') nesting += 1;
    }
    const indent = type ? Math.max(0, level ? Number(level[1]) - 1 : nesting - 1) : 0;
    if (list && list !== type) { result += `</${list}>`; list = ''; }
    if (type && !list) { result += `<${type}>`; list = type; }
    const tag = type ? 'li' : /^H[123]$/.test(paragraph.tagName) ? (paragraph.tagName === 'H3' ? 'h3' : 'h2') : 'p';
    const attr = indent ? ` class="ql-indent-${indent}"` : '';
    // No Chromium, o Quill une <li> irmãos sem uma quebra explícita.
    result += `<${tag}${attr}>${copy.innerHTML.trim()}${type ? '<br>' : ''}</${tag}>`;
  });
  if (list) result += `</${list}>`;
  if (result) return result;
  if (!texto.trim()) return null;
  const escaped = document.createElement('div');
  escaped.textContent = texto;
  return escaped.innerHTML.split(/\r?\n/).map((line) => `<p>${line || '<br>'}</p>`).join('');
}
